/* @flow */
import { RECEIVE_FOUNDRY_RESPONSE } from '../actions/foundry_response';
import {get, pick, map} from 'lodash';
import type { Action } from '../actions/types';

export default (state: NavigationState = [], action: Action): NavigationState => {
  switch (action.type) {
    case RECEIVE_FOUNDRY_RESPONSE:
      const items = get(action, 'data.page_data.navigation_items', []);

      const modifyNavigationItem = (Item: Object): Object => {
        return {
          ...pick(Item, ['id', 'display_name', 'path', 'children', 'promo_image_src', 'promo_url', 'promo_is_active']),
          label: Item.tagline || ''
        };
      };

      const navigationItemsModifier = (items: Array<NavigationItem>): NavigationState => {
        if (!items) {
          return [];
        }

        const modifiedItem = map(items, (item: Object): NavigationItem => modifyNavigationItem(item));

        return map(modifiedItem, ({ children, ...item }: Object): NavigationItem => ({
          ...item,
          children: navigationItemsModifier(children)
        }));
      };

      return navigationItemsModifier(items);

    default:
      return state;
  }
};

type NavigationState = Array<NavigationItem>;

type NavigationItem = {
  id: number,
  display_name: string,
  path: string,
  label: string,
  promo_image_id?: number,
  promo_image_src?: string,
  promo_url?: string,
  promo_is_active?: boolean,
  children?: Array<NavigationItem>
};
